import React, { Suspense } from 'react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import * as Sentry from '@sentry/browser';
import { fluentuiTheme } from '../../config/fluentuiTheme';
import { ThemeProvider as FluentUIThemeProvider } from '@fluentui/react';
import { ApolloProvider } from '@apollo/client';
import apolloClient from '../../utils/apollo/client';
import { Provider } from 'react-redux';
import store from '../../redux/store';
import { DimmerLoader } from '../../components/Loaders';
import ErrorPage from '../ErrorPage';
import { AnalyticsProvider } from '../../utils/analytics/AnalyticsProvider';
import { FloatingManager } from '../../components/FloatingManager';

interface IProps {
  children: React.ReactNode;
}

/**
 * This component will contains most of 3rd party hoc
 * probably there is a better name, the goal is to reduce complexity of App.tsx
 *
 * This can reduce the count wrapping in App.tsx and make it look cleaner..
 */
export default ({ children }: IProps) => {
  const FallbackComponent = ({ error }: FallbackProps) => {
    console.error('Fallback Error: ', error);
    Sentry.captureException(error);
    return <ErrorPage />;
  };

  return (
    <ErrorBoundary FallbackComponent={FallbackComponent}>
      <AnalyticsProvider debug={true}>
        <FluentUIThemeProvider
          theme={fluentuiTheme}
          className="fluent-ui-theme-provider-element"
        >
          <Provider store={store}>
            <ApolloProvider client={apolloClient}>
              <Suspense fallback={<DimmerLoader />}>{children}</Suspense>

              <FloatingManager />
            </ApolloProvider>
          </Provider>
        </FluentUIThemeProvider>
      </AnalyticsProvider>
    </ErrorBoundary>
  );
};
